module.exports = __webpack_public_path__ + "images/Kvadrat_Black-10e5c6.png";